// @ts-strict-ignore
import { NumberUtils } from '@shared/util/number-utils';
import { DrillingHoleSize } from '@3d-scene/model3d/util/drillinghole/drilling-hole-size';
import { ArticleVO } from '@article/model/vo/article.vo';

export class DrillingHoleInfo {
  private _usageId: string;
  // distance from start of mounting rail to center of the article
  public position: number;
  public positionOffset: number;
  public shapeType: string;
  public size: DrillingHoleSize;
  public drillDimmensionID: number;
  public accessoryArticles: ArticleVO[];
  public dirty: boolean = false;

  public get usageId(): string {
    return this._usageId;
  }

  public set usageId(value: string) {
    this._usageId = value;
  }

  public equals(info: DrillingHoleInfo): boolean {
    if (!info) {
      return false;
    }
    // usageId === info.usageId
    return this.position === info.position && this.shapeType === info.shapeType && this.size.equals(info.size) && (
        (NumberUtils.isNotNumber(this.drillDimmensionID) && NumberUtils.isNotNumber(info.drillDimmensionID))
        || (this.drillDimmensionID === info.drillDimmensionID)
      );
  }

  public clone(): DrillingHoleInfo {
    const cloneObject: DrillingHoleInfo = new DrillingHoleInfo();
    cloneObject.usageId = this.usageId;
    cloneObject.position = this.position;
    cloneObject.shapeType = this.shapeType;
    cloneObject.positionOffset = this.positionOffset;
    cloneObject.size = (!this.size ? null : this.size.clone());
    cloneObject.drillDimmensionID = this.drillDimmensionID;
    if (this.accessoryArticles) {
      cloneObject.accessoryArticles = this.accessoryArticles.concat();
    }
    cloneObject.dirty = this.dirty;
    return cloneObject;
  }
}
